export default __webpack_public_path__ + "assets/images/163d9b5d85dc0b5d1c5ed12c5cf33cf1.svg";